export default __webpack_public_path__ + "static/media/topic.40379c80.png";